import { FilingCabinetContext } from '@/Contexts/Authenticated/FilingCabinetContext';
import type { FilingCabinetItem } from '@/Models/FilingCabinet/FilingCabinet';
import { List, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import FilingCabinetItemLink from '../FilingCabinetItemLink/FilingCabinetItemLink';
import Styles from './FilingCabinet.module.scss';

function FilingCabinet({ filter }: Readonly<{ filter: string }>): React.ReactElement {
    const { t } = useTranslation();
    const { filingCabinet, clearFilingCabinet: clear } = useContext(FilingCabinetContext)!;

    const getItems = (): FilingCabinetItem[] => {
        if (!filter || filter === '') {
            return filingCabinet.files;
        }
        return filingCabinet.files.filter((x) => (x.title ?? '').toLowerCase().includes(filter.toLowerCase()));
    };

    const filingCabinetItems = getItems().map((x: FilingCabinetItem) =>
        <FilingCabinetItemLink key={x.ID} item={x} />,
    );
    const needsToShowCloseAll = filingCabinet.files.length > 0;

    return (
        <>
            <List>
                { filingCabinetItems }
            </List>
            { needsToShowCloseAll
                && (
                    <Box>
                        <Typography id={Styles.resetFilingCabinet} onClick={(_) => clear()}>{t('FilingCabinetCloseAll')}</Typography>
                    </Box>
                )
                || '' }
        </>
    );
}

export default FilingCabinet;
